import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class CalendarEventScope extends Resource {
    public override type = 'calendarEventScopes';

    @prop()
    public code!: string;

    @prop()
    public name!: string;

}
